import { template as template_ef74fb000af04922866ff2b1cd73bd6b } from "@ember/template-compiler";
import { t } from 'ember-intl';
export default template_ef74fb000af04922866ff2b1cd73bd6b(`
<div class="col d-flex h-100 justify-content-center align-items-center bi-no-data" ...attributes>
  {{t "status.0"}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
